import { isToday } from "date-fns"

import style from "./styles.module.scss"

import { formatToDayAndMonth } from "utils/datetime-format-utils"

interface Props {
    date: Date
}

export function DateDivider({ date }: Props) {
    return (
        <div className={style.container}>
            <div className={style.line} />
            <div className={style.date}>
                {isToday(date) ? "Сегодня" : formatToDayAndMonth(date)}
            </div>
        </div>
    )
}
